export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/ID-bc9da28df4836f8d7d7d4986eb3756b3.png";